import CircleIcon from '@mui/icons-material/Circle';
import { styled } from '@mui/material';

const Puce = styled(CircleIcon)(({ theme, color = '#000000' }) => ({
  fontSize: 12,
  color: color,
  marginRight: theme.spacing(1)
}));

export default Puce